import { render, staticRenderFns } from "./ItemSelectByFile.vue?vue&type=template&id=000b6b86&"
import script from "./ItemSelectByFile.vue?vue&type=script&lang=js&"
export * from "./ItemSelectByFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports